import React, { useRef } from 'react';

import { Input } from 'antd';

import { CUSTOMERS_WALL_QUICKFILTER_DEFAULT, hasQuickFiltersSet } from '@configs/WALLS_CONFIG';

import { useLayoutContext } from '@contexts/LayoutContext';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import {
    MOBILE_FILTERS_NESTED_ZINDEX,
    QuickFilterContainer,
    QuickFilterContainerMobile,
} from '@components/Filters/FilterForm/FilterFormUI';
import { NwLinkButton } from '@components/Gui/NwButton';
import NwDivider from '@components/Gui/NwDivider';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import NwIcon from '@components/Gui/NwIcon';
import TagFilterPicker from '@components/TagPicker/TagFilterPicker';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const CustomerQuickFilters = ({ onAfterChangeFilters, isMini }) => {
    const { selection, context } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { quickFilters } = selection;
    const { area } = context;

    const layoutContext = useLayoutContext();
    const { breakpoints, isMobile } = layoutContext;
    // sotto i 1024px questi filtri vivono dentro il pannello filtri a tutta pagina:
    // i drawer che aprono devono stargli sopra
    const inMobileFiltersPanel = breakpoints < 3;

    const nameRef = useRef();

    const sortOptions = [
        { label: 'Name', value: 'Name' },
        { label: 'ID', value: 'ID' },
    ];

    const handleChangeFilter = (name, value) => {
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: {
                ...quickFilters,
                [name]: value,
            },
        });
        if (onAfterChangeFilters) {
            onAfterChangeFilters();
        }
    };

    const handleResetQuickFilters = () => {
        cs_dispatch({
            type: 'ChangeQuickFilters',
            quickFilters: { ...CUSTOMERS_WALL_QUICKFILTER_DEFAULT },
        });
        if (onAfterChangeFilters) {
            onAfterChangeFilters();
        }
    };

    const customersTypeOptions = [
        { label: '*', value: 0 },
        { label: 'clients', value: 1 },
        { label: 'agencies', value: 2 },
        { label: 'services', value: 3 },
    ];
    if (area === 'scouting') {
        customersTypeOptions.splice(1, 1);
    }

    // Versione ridotta: solo per la striscia mini (wall in sidebar). Nel pannello filtri
    // mobile c'è spazio verticale per i quick filters completi.
    if (isMobile && isMini) {
        return (
            <QuickFilterContainerMobile>
                <div className="quick-filter-item">
                    <RadioButtonGroup
                        value={quickFilters.category}
                        onChange={(value) => {
                            handleChangeFilter('category', value);
                        }}
                        size="small"
                        options={customersTypeOptions}
                    />
                </div>
                <div className="quick-filter-item">
                    <TagFilterPicker
                        itemType="Customer"
                        selectedOptions={quickFilters.tagFilter}
                        filterMode={quickFilters.tagFilterMode}
                        onChange={(_, _tagFilter) => {
                            handleChangeFilter('tagFilter', _tagFilter);
                        }}
                        onFilterModeChange={(mode) => {
                            handleChangeFilter('tagFilterMode', mode);
                        }}
                    />
                </div>
            </QuickFilterContainerMobile>
        );
    }

    return (
        <QuickFilterContainer $isMini={isMini}>
            {!isMini && <NwDivider>quick search</NwDivider>}
            {hasQuickFiltersSet(quickFilters, CUSTOMERS_WALL_QUICKFILTER_DEFAULT) && (
                <div className="quick-filter-line">
                    <NwLinkButton
                        icon={byPrefixAndName.fass['undo']}
                        label="reset quick filters"
                        onClick={handleResetQuickFilters}
                    />
                </div>
            )}
            {!isMobile && (
                <div className="quick-filter-line">
                    <Input
                        ref={nameRef}
                        allowClear
                        autoComplete="off"
                        placeholder="Filter by name"
                        prefix={<NwIcon icon={byPrefixAndName.fasl['search']} />}
                        onChange={(e) => {
                            handleChangeFilter('nameFilter', e.target.value);
                        }}
                        value={quickFilters.nameFilter}
                    />
                </div>
            )}
            <div className="quick-filter-line">
                <div className="quick-filter-item">
                    <TagFilterPicker
                        itemType="Customer"
                        selectedOptions={quickFilters.tagFilter}
                        filterMode={quickFilters.tagFilterMode}
                        zIndex={inMobileFiltersPanel ? MOBILE_FILTERS_NESTED_ZINDEX : undefined}
                        onChange={(_, _tagFilter) => {
                            handleChangeFilter('tagFilter', _tagFilter);
                        }}
                        onFilterModeChange={(mode) => {
                            handleChangeFilter('tagFilterMode', mode);
                        }}
                    />
                </div>
            </div>
            <div className="quick-filter-line">
                <div className="quick-filter-item">
                    <RadioButtonGroup
                        value={quickFilters.category}
                        onChange={(value) => {
                            handleChangeFilter('category', value);
                        }}
                        size="small"
                        options={customersTypeOptions}
                    />
                </div>
            </div>
            {isMini && (
                <div className="quick-filter-line">
                    <div className="quick-filter-item">
                        <span className="before">sort by</span>
                        <RadioButtonGroup
                            value={quickFilters.sort}
                            onChange={(value) => handleChangeFilter('sort', value)}
                            size="small"
                            options={sortOptions}
                        />
                    </div>
                </div>
            )}
        </QuickFilterContainer>
    );
};

export default CustomerQuickFilters;
